import { PersonBus } from "./PersonBus";
import { CustomerLogoBus } from "./CustomerLogoBus";
import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { GeographyInfoBus } from "./GeographyInfoBus";

export class CustomerOnbDataBus extends BaseBus
{

    constructor(data: CustomerOnbDataBus) {
        super(data);
    }

    CID(): any {
        return this.customerOnbQuestionId;
    }
    initialize(data: CustomerOnbDataBus) {
        super.initialize(data);
        this.insertDt = CommonFunctions.getDate(data.insertDt);
        this.updateDt = CommonFunctions.getDate(data.updateDt);
    }

    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: CustomerOnbDataBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();

        if (this.hasId) {
            //this.updateDt = dateNow;
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        // this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        if (this.hasId) {
            this.updateUserId = userId;
        }
        else {
            this.insertDt = date;
            this.insertUserId = userId;
            this.updateUserId = userId;
            this.insertDate = date;
        }
    }
    setId(id: any) {
        this.customerOnbDataBusId = id;
    }

        customerId: string;
        customerOnbDataBusId: string;
    customerOnbQuestionId: string;
    question: string;
        questionData: string;
        customerOnbCategoryId: string;
        customerOnbCategory: string;
        updateUserId: string;
        insertUserId: string;
        insertDt: Date;
    updateDt: Date;
    insertDate: Date;
    updateDate: Date;

}
